import {
    guideClickOnElement, guideWaitForElement,
    guideClickOnElementInTopActivity, guideFillInput, guideWaitForElementLong, guideWaitForValue
} from "@/components/dashboard/guides/guidNavigation";

import {isBelowBreakpoint} from "@/utils/Dom";
import EventBus from "@/utils/EventBus";

export function createManageSubscriptionGuideSteps(initialMenu) {
    let menu = initialMenu;

    return [
        {
            target: '#dark-navbar',
            header: {
                title: 'Hello There',
            },
            content: "I’ll guide you through managing your subscription. Let’s get started!",
            imageSrc: "https://silkplm.com/wp-content/uploads/2024/11/Product-Tour-welcome-screen.png",
            beforeNext: async() => {
                if(isBelowBreakpoint("md")) {
                    EventBus.$emit('openMainMenu');
                    menu = "mobile-";
                } else {
                    menu = "";
                }
            }
        },
        {
            target: () => `#${menu}m-adm`,
            header: {
                title: 'First Step',
            },
            content: "First, open this panel.",
            beforeNext: async () => {
                menu = isBelowBreakpoint("md") ? "mobile-" : "";
                if(isBelowBreakpoint("md")) {
                    EventBus.$emit('openMainMenu');
                    await guideClickOnElement(`#${menu}m-adm`);
                } else {
                    await guideClickOnElement('#m-adm');
                }
                await sleep(500);
            }
        },
        {
            target: () => `#${menu}adm-subscription`,
            header: {
                title: 'Last Step',
            },
            content: "Now, proceed here. After clicking, you’ll be redirected to a page where you can view and manage your subscriptions and available options. Good luck!",
            beforeNext: async () => {
                // Aktualizuj menu na podstawie bieżącego rozmiaru ekranu
                menu = isBelowBreakpoint("md") ? "mobile-" : "";
            }
        },
    ];
}
